import moment, { Moment } from 'moment';
import { FormatTimeUnit } from '../model';
import momentTimeZone from 'moment-timezone';

export const getFormatTime = (date?: Date) => {
  if (!date) return '';
  const strDate = date.toString();
  if (strDate.indexOf('0000-00-00') !== -1) {
    return '--';
  }
  // 格式需要转化
  const formattedDate = strDate.replace('T', ' ').replace('.000Z', '');
  return formattedDate;
};

// utc时间
export const getUtcTime = (date?: Moment | Date | number | string) => {
  if (!date) return '';
  const formattedDate = moment.utc(date);
  if (formattedDate.isValid()) {
    return formattedDate.format('YYYY-MM-DD HH:mm:ss');
  }
  return '';
};

// 时间转换成用户设置的时区
export const getLocalTime = (time: any, timeZone?: string) => {
  // 检查传入的时间类型是否为10位数时间戳（秒级）
  const isUnixTime = Number.isInteger(time) && String(time).length === 10;

  // 根据时间类型创建moment对象：如果是Unix时间戳则乘以1000转为毫秒，否则直接解析
  const momentTime = isUnixTime
    ? momentTimeZone.utc(time * 1000)
    : momentTimeZone.utc(time);

  // 获取用户浏览器的默认时区
  const defaultTimeZone = momentTimeZone.tz.guess();

  // 将时间转换为指定时区格式（如未指定则使用浏览器默认时区），并格式化为标准时间字符串

  return momentTime
    .tz(timeZone || defaultTimeZone)
    .format('YYYY-MM-DD HH:mm:ss') !== 'Invalid date'
    ? momentTime.tz(timeZone || defaultTimeZone).format('YYYY-MM-DD HH:mm:ss')
    : time;
};

export const getUserConfigZoneTimeByUTC8 = (time: any, timeZone?: string) => {
  try {
    if (!time || typeof time !== 'string') {
      return '';
    }
    const momentTime = momentTimeZone.tz(time, 'Asia/Shanghai').utc();
    const defaultTimeZone = momentTimeZone.tz.guess();
    return momentTime
      .tz(timeZone || defaultTimeZone)
      .format('YYYY-MM-DD HH:mm:ss');
  } catch (err) {
    return '';
  }
};

const timeFormat = (num: number) => {
  if (num < 10) {
    return `0${num}`;
  }
  return num;
};

const generate = () => {
  const time = new Date();
  const getMilliseconds = time.getMilliseconds();
  const day = `${time.getFullYear()}-${timeFormat(
    time.getMonth() + 1
  )}-${timeFormat(time.getDate())}`;
  const hours = time.toTimeString().slice(0, 8);
  return {
    timeStamp: +time,
    day,
    hours,
    seconds: getMilliseconds,
  };
};

export const getTimeSeconds = () => {
  const time = generate();
  return `${time.day} ${time.hours}`;
};

export const getTimeFull = () => {
  const time = generate();
  return `${time.day} ${time.hours} ${time.seconds}`;
};

export const getLastDay = () => {
  const curTime = new Date();
  const time = new Date(curTime.getTime() - 24 * 60 * 60 * 1000);
  return `${time.getFullYear()}-${timeFormat(time.getMonth() + 1)}-${timeFormat(
    time.getDate()
  )}`;
};

export const getDay = () => {
  const time = new Date();
  return `${time.getFullYear()}-${timeFormat(time.getMonth() + 1)}-${timeFormat(
    time.getDate()
  )}`;
};

export function formatDate(date: string) {
  if (date.length === 8) {
    return moment(date).format('YYYY-MM-DD');
  }

  return date;
}

export function formatDateCustom(date: string | number, type?: any) {
  if (type === 'month') return moment(date).format('MM');
  return moment(date).format('MM-DD');
}

export function formatDateType(date: string, type?: string) {
  if (type === 'month') return moment(date).format('YYYY-MM');
  return moment(date).format('MM-DD');
}
export function formatDateMonth(date: string) {
  if (date.length === 6) {
    return moment(date).format('YYYY-MM');
  }

  return date;
}

// 因为不清楚上面两个方法在使用中的具体逻辑 所以不做复用
export function formatDayOrMonth(date: string) {
  if (date.length === 8) {
    return moment(date).format('YYYY-MM-DD');
  }
  if (date.length === 6) {
    return moment(date).format('YYYY-MM');
  }

  return date;
}

export function briefDate(date: string, type?: any, i?: number) {
  if (type === 'day') {
    return moment(date).format('MM-DD');
  }
  if (type === 'week') {
    if (i || i === 0) {
      return `近${i + 1}周`;
    }
  }

  if (type === 'month') {
    return moment(date).format('MM');
  }
  return date;
}

export function formatDateYtoM(date: string) {
  return moment(date).format('YYYY年MM月');
}
/**
 * @param text 需要转换的文本或者是数值，数值单位是s
 * @param precision 保留的小数位
 */
export const formatAsUnit = (
  text: number | string,
  precision = 2,
  unit: FormatTimeUnit = FormatTimeUnit.Hour
) => {
  const type = typeof text;
  if (type === 'string') {
    return `${text} ${unit}`;
  }
  if (type === 'number') {
    let res: number = +text;
    switch (unit) {
      case FormatTimeUnit.Year:
        res = res / (365 * 24 * 3600);
        break;
      case FormatTimeUnit.Month:
        res = res / (30 * 24 * 3600);
        break;
      case FormatTimeUnit.Day:
        res = res / (24 * 3600);
        break;
      case FormatTimeUnit.Hour:
        res = res / 3600;
        break;
      case FormatTimeUnit.Min:
        res = res / 60;
        break;
    }
    return `${res.toFixed(precision)} ${unit}`;
  }
  return text;
};

// 格式化时间为最近 时分秒天,单位为ms
export const formatAsLatest = (time: number, unit = 'en') => {
  const second = time / 1000;
  const MIN = 60;
  const HOUR = MIN * 60;
  const DAY = HOUR * 24;

  const unitText: {
    [key: string]: { s: string; min: string; h: string; d: string };
  } = {
    en: {
      s: 's',
      min: 'min',
      h: 'h',
      d: 'd',
    },
    zh: {
      s: '秒',
      min: '分钟',
      h: '小时',
      d: '天',
    },
  };

  if (second < MIN) {
    return `${second}s`;
  }
  if (second < HOUR) {
    const min = Math.round(second / MIN);
    return `${min}${unitText[unit].min}`;
  }
  if (second < DAY) {
    const hour = Math.floor(second / HOUR);
    const min = Math.round((second - hour * HOUR) / MIN);
    return `${hour}${unitText[unit].h}${min}${unitText[unit].min}`;
  }
  const day = Math.floor(second / DAY);
  const hour = Math.floor((second - day * DAY) / HOUR);
  const min = Math.round((second - day * DAY - hour * HOUR) / MIN);
  return `${day}${unitText[unit].d}${hour}${unitText[unit].h}${min}${unitText[unit].min}`;
};
